import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const DownloadResumeButton = () => {
  const handleDownload = () => {
    // For now, this will link to the provided resume URL
    const resumeUrl = 'https://ogulcan.cankaya.xyz/AhmetOgulcanCankaya.pdf';
    window.open(resumeUrl, '_blank');
  };

  return (
    <Button
      onClick={handleDownload}
      className="fixed bottom-8 right-8 z-50 bg-cyan-500 hover:bg-cyan-600 text-white px-6 py-6 rounded-full shadow-lg shadow-cyan-500/50 hover:shadow-xl hover:shadow-cyan-500/60 transition-all duration-300 hover:scale-105 flex items-center gap-2"
    >
      <Download className="w-5 h-5" />
      <span className="hidden md:inline">Download Resume</span>
    </Button>
  );
};

export default DownloadResumeButton;